// LIFF ID.
// 説明ページ（prod） : 1656105485-mZP8EdEf
// 説明ページ（try） : 1656105485-5pibxfeI
export const LIFF_ID = "1656105485-uInJSx58" // e.g. "1657244793-4K63WeeV"
// Universal Link URL.
export const UNIVERSAL_LINK_URL = "https://m.e-welcia.com/app/applink/lineuser.html";
